module.exports = __webpack_public_path__ + "img/agent-accounts.52583a76.svg";